import styled, { css } from 'styled-components';

import { DropdownProps } from '.';

export const Element = styled.div<{ disabled?: boolean }>`
  ${({ disabled }) => css`
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    opacity: ${disabled ? 0.6 : 1};
    pointer-events: ${disabled ? 'none' : 'auto'};
  `}
`;

export const Content = styled.div<DropdownProps>`
  ${({ theme, position, width }) => css`
    display: flex;
    width: ${() => width};
    background: ${theme.colors.neutral.neutral0};
    box-shadow: 0 0 1rem rgba(36, 36, 36, 0.12);
    flex-direction: column;
    border-radius: 12px;
    position: absolute;
    top: 40px;
    left: ${position ? 'auto' : '0'};
    right: ${position ? `${position}rem` : 'auto'};
  `}
`;

export const Title = styled.span`
  padding: 1rem 0rem 0rem 2.4rem;
  font-size: 1.2rem;
`;

type WrapperProps = {
  isOpen?: boolean;
};

const wrapperModifiers = {
  open: () => css`
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
    z-index: 5;
  `,
  close: () => css`
    opacity: 0;
    pointer-events: none;
    transform: translateY(-2rem);
  `,
};

export const Wrapper = styled.div<WrapperProps>`
  ${({ isOpen }) => css`
    position: relative;

    ${Content} {
      transition: transform 0.2s ease-in, opacity 0.2s ease-in-out;
      z-index: 10000;
      ${isOpen && wrapperModifiers.open()}
      ${!isOpen && wrapperModifiers.close()}
    }
  `}
`;
